import React, { createContext, type FC, useContext, useMemo } from 'react';

interface FocusedFieldProviderProps {
  children: React.ReactNode;
}

interface FocusedFieldProps {
  focusedFieldId: string | undefined;
  setFocusedFieldId: (id: string | undefined) => void;
}

const FocusedFieldContext = createContext<FocusedFieldProps | undefined>(
  undefined,
);

export const FocusedFieldProvider: FC<FocusedFieldProviderProps> = ({
  children,
}) => {
  const [focusedFieldId, setFocusedFieldId] = React.useState<
    string | undefined
  >(undefined);

  const contextValue = useMemo(() => {
    return {
      focusedFieldId,
      setFocusedFieldId,
    };
  }, [focusedFieldId, setFocusedFieldId]);

  return (
    <FocusedFieldContext.Provider value={contextValue}>
      {children}
    </FocusedFieldContext.Provider>
  );
};

export function useFocusedField() {
  const context = useContext(FocusedFieldContext);
  if (context === undefined) {
    throw new Error(
      'useFocusedField must be used within a FocusedFieldProvider',
    );
  }
  return context;
}
